import React, { useState, useEffect } from 'react'
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import usePortalService from '../services/PortalService';
import exclamationCircle from '../images/exclamation-circle.svg';

import { Form } from 'react-bootstrap';
import { ManagerNavbar } from '../Components/Navbars';

export const EditProfileManager = () => {
    const navigate = useNavigate();

    const {getManagerInformation, updateInformationManager, sendConfirmLink} = usePortalService();

    const [lastName, setLastName] = useState('');
    const [lastNameDirty, setLastNameDirty] = useState(false);
    const [lastNameError, setLastNameError] = useState('');

    const [firstName, setFirstName] = useState('');
    const [firstNameDirty, setFirstNameDirty] = useState(false);
    const [firstNameError, setFirstNameError] = useState('');

    const [patronymic, setPatronymic] = useState('');

    const [post, setPost] = useState('');
    const [postDirty, setPostDirty] = useState(false);
    const [postError, setPostError] = useState('');

    const regEmail = /[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+/;
    const [email, setEmail] = useState('');
    const [emailDirty, setEmailDirty] = useState(false);
    const [emailError, setEmailError] = useState('');

    const [emailChanged, setEmailChanged] = useState(false);
    const [isConfirm, setIsConfirm] = useState(true);
    const [emailSended, setEmailSended] = useState(false);

    const regPhone = /^\d{11}$/;
    const [phone, setPhone] = useState('');
    const [phoneDirty, setPhoneDirty] = useState(false);
    const [phoneError, setPhoneError] = useState('');

    const lastNameHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLastName(e.target.value)
        if (e.target.value.length < 1) {
            setLastNameError('Введите фамилию')
        } else if (e.target.value.length < 2) {
            setLastNameError('Фамилия не может состоять из одного символа')
        } else {
            setLastNameError('')
        }
    }

    const firstNameHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFirstName(e.target.value)
        if (e.target.value.length < 1) {
            setFirstNameError('Введите имя')
        } else if (e.target.value.length < 2) {
            setFirstNameError('Имя не может состоять из одного символа')
        } else {
            setFirstNameError('')
        }
    }

    const patronymicHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPatronymic(e.target.value)
    }

    const postHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPost(e.target.value)
        if (e.target.value.length == 0) {
            setPostError('Введите должность')
        } else if (e.target.value.length < 2) {
            setPostError('Должность не может состоять из одного символа')
        } else {
            setPostError('')
        }
    }

    const emailHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value)
        setEmailChanged(true)
        if (!regEmail.test(String(e.target.value).toLowerCase())) {
            setEmailError('Некорректный email')
        } else {
            setEmailError('')
        }
    }

    const phoneHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPhone(e.target.value)
        if (!regPhone.test(String(e.target.value).toLowerCase())) {
            setPhoneError('Некорректный номер телефона')
        } else {
            setPhoneError('')
        }
    }

    const sendHandler = () => {
        if (!emailSended) {
            sendConfirmLink();
            setEmailSended(true);
        }
    }

    const blurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        switch (e.target.name) {
            case 'lastName':
                setLastNameDirty(true)
                break;
            case 'firstName':
                setFirstNameDirty(true)
                break;
            case 'post':
                setPostDirty(true)
                break;
            case 'email':
                setEmailDirty(true)
                break;
            case 'phone':
                setPhoneDirty(true)
                break;
        }
    }

    useEffect(() => {
        getManagerInformation().then(result => {
            setFirstName(result.manager.firstName);
            setLastName(result.manager.lastName);
            setPatronymic(result.manager.patronymic);
            setPost(result.manager.position);
            setEmail(result.manager.login);
            setPhone(result.manager.phoneNumber);
            setIsConfirm(result.manager.isConfirm);
        });
    }, []);

    const saveHandler = async () => {
        if (firstNameError || lastNameError || postError || emailError || phoneError)
        {
            setFirstNameDirty(true)
            setLastNameDirty(true)
            setPostDirty(true)
            setEmailDirty(true)
            setPhoneDirty(true)
        } else {
            const result = await updateInformationManager({
                lastName,
                firstName,
                patronymic,
                position: post,
                email,
                phoneNumber: phone
            });
    
            if (result.success) {
                if (result.isSendEmailConfirm) {
                    sessionStorage.setItem('email', email)
                    sessionStorage.setItem('headingAlert', 'Изменения успешно сохранены!')
                }
                navigate("/");
            }
        }
    }

    return (
        <>
            <ManagerNavbar />
            <div style={{width: '100%', maxWidth: '549px', paddingLeft: '6%', paddingRight: '6%', paddingTop:'46px'}}>
                <h1 style={{marginBottom: '24px'}}> Аккаунт </h1>
                <Form>
                    <div className="form-group">
                        <Form.Label> Фамилия </Form.Label>
                        <Form.Control 
                            type="text" 
                            name='lastName'
                            value={lastName} 
                            onBlur={blurHandler} 
                            onChange={lastNameHandler} 
                        />
                        {(lastNameDirty && lastNameError) && <p className="error-alert">{lastNameError}</p>}
                    </div>
                    <div className="form-group">
                        <Form.Label> Имя </Form.Label>
                        <Form.Control 
                            type="text" 
                            name='firstName'
                            value={firstName} 
                            onBlur={blurHandler} 
                            onChange={firstNameHandler} 
                        />
                        {(firstNameDirty && firstNameError) && <p className="error-alert">{firstNameError}</p>}
                    </div>
                    <div className="form-group">
                        <Form.Label> Отчество </Form.Label>
                        <Form.Control 
                            type="text" 
                            name='patronymic'
                            value={patronymic} 
                            onChange={patronymicHandler} 
                        />
                    </div>
                    <div className="form-group">
                        <Form.Label> Должность </Form.Label>
                        <Form.Control 
                            type="text" 
                            name='post'
                            value={post} 
                            onBlur={blurHandler} 
                            onChange={postHandler} 
                        />
                        {(postDirty && postError) && <p className="error-alert">{postError}</p>}
                    </div>
                    <div className="pair-input">
                        <Form.Group className="form-group first-in-pair" controlId="formEmail">
                            <Form.Label> Email </Form.Label>
                            <Form.Control 
                                type="email" 
                                name='email'
                                value={email} 
                                onBlur={blurHandler} 
                                onChange={emailHandler} 
                            />
                            {(emailDirty && emailError) && <p className="error-alert">{emailError}</p>}
                            {(!isConfirm && !emailChanged) && 
                                <>
                                    <p style={{color: '#8C99A6', paddingTop:'4px'}}> 
                                        <img src={exclamationCircle}/> Подтвердите адрес – перейдите по ссылке в письме. 
                                        <p onClick={sendHandler}> Отправить повторное письмо </p> 
                                    </p>
                                </>
                            }
                        </Form.Group>
                        <Form.Group className="form-group second-in-pair" controlId="formPhone">
                            <Form.Label> Телефон </Form.Label>
                            <Form.Control 
                                type="text" 
                                name='phone'
                                value={phone} 
                                onBlur={blurHandler} 
                                onChange={phoneHandler} 
                            />
                            {(phoneDirty && phoneError) && <p className="error-alert">{phoneError}</p>}
                        </Form.Group>
                    </div>
                    <Button type="primary" style={{marginRight: '20px'}} onClick={saveHandler}> Сохранить </Button>
                    <button className="grey-button" onClick={() => window.history.back()}> Отмена </button>
                </Form>
            </div>
        </>
    )
}